module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/XRXW3I6Li01BKofAnsSUbuvIWzgPDEtj.9d460646.woff2";